import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Grid,
  Typography,
  Pagination,
} from "@mui/material";
import DownloadButton from "./PDFDownloader";
import { logger } from "../../../utils/logger";

const ITEMS_PER_PAGE = 12;

const LabelPage = ({ data = [], type, username, role }) => {
  const [page, setPage] = useState(1);

  // Memoize filtered data to avoid unnecessary recalculations
  const filteredData = useMemo(() => {
    if (!data || data.length === 0) return [];
    return data; // Apply filter logic here if needed
  }, [data]);

  // Calculate total pages and paginated data
  const totalPages = useMemo(
    () => Math.ceil(filteredData.length / ITEMS_PER_PAGE),
    [filteredData]
  );
  const paginatedData = useMemo(
    () =>
      filteredData.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE),
    [filteredData, page]
  );

  // Reset to page 1 when data changes
  useEffect(() => {
    setPage(1);
  }, [data, type]);

  // Log when page or data changes
  useEffect(() => {
    if (!data || data.length === 0) return;

    logger.info("Data filtered and displayed", {
      username: username,
      role: role,
      filterType: type,
      totalRecords: filteredData.length,
      displayedRecords: paginatedData.length,
      currentPage: page,
      totalPages,
    });
  }, [filteredData.length, paginatedData.length, page, totalPages, username, role, type, data]);



  return (
    <Box sx={{ padding: 1 }}>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <DownloadButton
          data={filteredData}
          type={type}
          username={username}
          role={role}
        />
      </Box>
      <Grid container spacing={1}>
        {paginatedData.length > 0 ? (
          paginatedData.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box
                sx={{
                  padding: 1,
                  minHeight: "100px",
                  border: "1px solid #ccc",
                  height: "160px",
                }}
              >
                <Typography variant="subtitle2" fontWeight="bold">
                  #{item.donorId}
                </Typography>
                <Typography variant="body1">
                  {item.salutation} {item.initial} {item.firstName}{" "}
                  {item.lastName}
                </Typography>
                <Typography variant="body2">{item.address}</Typography>
                <Typography variant="body2">{item.address1}</Typography>
                {item.address2 && (
                  <Typography variant="body2">{item.address2}</Typography>
                )}
                <Typography variant="body2">
                  {item.city} - {item.pincode}
                </Typography>
                {(item.mobile1 || item.mobile2) && (
                  <Typography variant="body2" fontWeight="bold">
    Mob.: {item.mobile1}
    {item.mobile1 && item.mobile2 && ", "}
    {item.mobile2}
  </Typography>
                )}
              </Box>
            </Grid>
          ))
        ) : (
          <Grid item xs={12}>
            <Typography variant="body1">No data found</Typography>
          </Grid>
        )}
      </Grid>

      {/* Pagination controls */}
      {totalPages > 1 && (
        <Box display="flex" justifyContent="center" mt={6} mb={2}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export default LabelPage;
